import React from 'react'; 
import WithConsumer from '../context/WithConsumer';
import GravityForm from "react-gravity-form";
import { Parallax } from 'react-scroll-parallax';
import  { Redirect } from 'react-router-dom';
import Foot from './Foot';

const AccountSettings = ({ context }) => {
		 
    const posts = () => context.posts;
    const post = posts()[0];
    
    if (post) {
	    
	    const ctxUser = () => context.user;
		const user = ctxUser();
	    
    	return (
	    	
	    	<div className="l-block l-block--max-width">
			        	
	        	<div className="l-grid l-grid--large-gutter">
		        	<div className="l-grid__col l-grid__col--m-7-12 l-grid__col--l-6-12">
			        	<h1 className="c-heading c-heading--space">Customer Dashboard<br />Welcome { user.first_name }</h1>
		        		{user.company &&
			        		<div className="c-account__details">
			        			<p className="c-account__details__label">Company</p>
			        			<p className="c-account__details__value">{ user.company }</p>
			        		</div>
		        		}
		        		{user.abn &&
			        		<div className="c-account__details">
			        			<p className="c-account__details__label">ABN</p>
			        			<p className="c-account__details__value">{ user.abn }</p>
			        		</div>
		        		}
					</div>
					<div className="l-grid__col l-grid__col--m-5-12 l-grid__col--l-6-12">
						<div className="c-content-block scope-text-account">
							<hr />
							{post.help &&
								<div dangerouslySetInnerHTML={ {__html: post.help} }></div>
							}
						</div>
					</div>
				</div>
    		
			</div>
    	)
	    		    	
	} else {
		return null
	}
};
export default WithConsumer(AccountSettings);